import PropTypes from "prop-types";
import SiteLayout from "../Layout/SiteLayout";
import ModernHeader from "./ModernHeader";
import styles from "./HomeLayout.module.scss";
import useAuth from "../../hooks/useAuth";
import LoginPage from "../../features/login/LoginPage";
import Loader from "../Loader/Loader";
const HomeLayout = ({ children, className = "" }) => {
  const { isLogged, isLoading, isInstitution } = useAuth();
  const authenticated = isLogged || isInstitution;

  return authenticated ? (
    <SiteLayout className={`${styles.homeLayout} ${className}`}>
      <ModernHeader />
      <main className={styles.homeContent}>
        <div className={styles.landingContainer}>{children}</div>
      </main>
    </SiteLayout>
  ) : isLoading ? (
    <Loader />
  ) : (
    <LoginPage />
  );
};
HomeLayout.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};

export default HomeLayout;
